module.exports = __webpack_public_path__ + "static/media/gender-men.a4b41b2b.svg";